import React from "react";
import { useI18n } from "@/i18n/I18nContext";

export default function LanguageToggle({ compact = false, testidPrefix = "lang-toggle" }) {
  const { lang, setLang } = useI18n();
  const langs = [
    { code: "fr", label: "FR" },
    { code: "en", label: "EN" },
  ];

  return (
    <div
      role="group"
      aria-label="Language"
      className={`inline-flex items-center rounded-full border border-slate-200 bg-white p-0.5 ${
        compact ? "text-xs" : "text-sm"
      }`}
      data-testid={testidPrefix}
    >
      {langs.map((l) => {
        const active = lang === l.code;
        return (
          <button
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`${testidPrefix}-${l.code}`}
            aria-pressed={active}
            className={`px-3 py-1.5 rounded-full font-semibold tracking-wider transition-all ${
              active
                ? "bg-navy text-white shadow-sm"
                : "text-slate-600 hover:text-navy"
            }`}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
